export const areArraysEqual = <T>(a?: readonly T[], b?: readonly T[]): boolean => {
  if (a === b) return true;
  if (!a || !b) return false;
  if (a.length !== b.length) return false;
  return a.every((item, index) => item === b[index]);
};
